import React from "react";

const CircularLoader = () => {
  return (
    <div className="loader-container my-1">
      <div className="circular-loader"></div>
    </div>
  );
};

export default CircularLoader;
